// extracted by mini-css-extract-plugin
module.exports = {"mtf44rd":"mtf44rd","p1p99shk":"p1p99shk"};